var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "calendar_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.316 9.048H44.77v-5.09h5.09v5.09h10.183V19.23h-56V9.048h10.182v-5.09h5.09zM4.043 24.321v35.636h56V24.321z",
    clipRule: "evenodd"
  })));
};
export { SvgCalendar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE5LjMxNTUgOS4wNDgxOEg0NC43N1YzLjk1NzI4SDQ5Ljg2MDlWOS4wNDgxOEg2MC4wNDI3VjE5LjIzSDQuMDQyNzJWOS4wNDgxOEgxNC4yMjQ1VjMuOTU3MjhIMTkuMzE1NVY5LjA0ODE4Wk00LjA0MjcyIDI0LjMyMDlWNTkuOTU3M0g2MC4wNDI3VjI0LjMyMDlINC4wNDI3MloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";